// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rockruff: PokeData = {
  "id": 744,
  "name": "rockruff",
  "height": 5,
  "weight": 92,
  "base_experience": 56,
  "types": [
    PokeType.ROCK
  ],
  "api_moves": [
    "sand-attack",
    "tackle",
    "leer",
    "bite",
    "roar",
    "rock-throw",
    "double-team",
    "rock-slide",
    "scary-face",
    "crunch",
    "odor-sleuth",
    "rock-tomb",
    "howl",
    "rock-climb",
    "stone-edge",
    "stealth-rock"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "rock-throw",
    "rock-slide",
    "scary-face",
    "crunch",
    "rock-tomb",
    "stealth-rock",
    "stone-crush",
    "boulder_bash",
    "seismic-toss",
    "rock-smash"
  ],
  "evolution_chain": {
    "id": 383,
    "item": null,
    "species": [
      {
        "name": "rockruff",
        "order": 744,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lycanroc",
        "order": 745,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": 744,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "dusk",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42.5,
    "speed": 60,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
